export const menus = {
  headhunter: [
    {
      name: '招聘需求',
      routing: 'headhunter-home/hiring-needs',
    },
    {
      name: '面试官日程',
      routing: 'headhunter-home/invite-schedule',
    },
    {
      name: '当日约面',
      routing: 'headhunter-home/today-interview',
    },
    {
      name: '面试列表',
      routing: 'headhunter-home/interview-list',
    },
    {
      name: '入职跟踪',
      routing: 'headhunter-home/enter-list',
    },
    {
      name: '个人数据',
      routing: 'headhunter-home/personal-data',
    },
    {
      name: '邀约分配',
      routing: 'headhunter-home/data-allot',
    },
    {
      name: '管理报表',
      routing: 'headhunter-home/management-data',
    },
  ],
  personnel: [
    {
      name: '在职员工',
      routing: 'personnel-home/staff',
    },
    {
      name: '发布招聘',
      routing: 'personnel-home/post-recruitment',
    },
    {
      name: '办理入职',
      routing: 'personnel-home/entry',
    },
    {
      name: '办理调动',
      routing: 'personnel-home/transfer',
    },
    {
      name: '薪资调整',
      routing: 'personnel-home/salary',
    },
    {
      name: '考勤报表',
      routing: 'personnel-home/attendance-report',
    },
    {
      name: '办理离职',
      routing: 'personnel-home/dimission',
    },
    {
      name: '黑名单管理',
      routing: 'personnel-home/black-list',
    },
  ],
  personnelInit: [
    {
      name: 'offer模板',
      routing: 'personnel-initialization/offer',
    },
    {
      name: '离职原因',
      routing: 'personnel-initialization/label',
    },
    {
      name: '主动离职问卷',
      routing: 'personnel-initialization/label',
    },
    {
      name: '被动离职标签',
      routing: 'personnel-initialization/label',
    },
    {
      name: '黑名单标签',
      routing: 'personnel-initialization/label',
    },
  ],
  institution: [
    {
      name: '门店设置',
      routing: 'institution/manage',
    },
    {
      name: '部门岗位',
      routing: 'institution/structure',
    },
    {
      name: '岗位模板',
      routing: 'institution/dutiesTpl',
    },
    {
      name: '动态记录',
      routing: 'institution/dynamic',
    },
  ],
  company: [
    {
      name: '公司管理',
      routing: 'company/manage',
    },
    {
      name: '部门岗位',
      routing: 'company/structure',
    },
    {
      name: '岗位模板',
      routing: 'company/dutiesTpl',
    },
    {
      name: '动态记录',
      routing: 'company/dynamic',
    },
  ],
  equally: [
    {
      name: '公摊管理',
      routing: 'equally/manage',
    },
    {
      name: '部门岗位',
      routing: 'equally/structure',
    },
    {
      name: '岗位模板',
      routing: 'equally/dutiesTpl',
    },
    {
      name: '动态记录',
      routing: 'equally/dynamic',
    },
  ],
  supply: [
    {
      name: '供应管理',
      routing: 'supply/manage',
    },
    {
      name: '部门岗位',
      routing: 'supply/structure',
    },
    {
      name: '岗位模板',
      routing: 'supply/dutiesTpl',
    },
    {
      name: '动态记录',
      routing: 'supply/dynamic',
    },
  ],
  role: [
    {
      name: '岗位权限',
      routing: 'role/duties-role',
    },
    {
      name: '超级管理员',
      routing: 'role/super-admin',
    },
    {
      name: '权限调整记录',
      routing: 'role/role-record',
    },
  ],
  punish: [
    {
      name: '考勤处罚',
      routing: 'punish/attendance-manage',
    },
    {
      name: '投诉处罚',
      routing: 'punish/complaint-manage',
    },
  ],
  label: [
    {
      name: '投诉标签',
      routing: 'label/complaints-label',
    },
    {
      name: '顾客标签',
      routing: 'label/customer-label',
    },
    {
      name: '建档标签',
      routing: 'label/dynamic-label',
    },
    {
      name: '人事标签',
      routing: 'label/personnel-label',
    },
  ],
};
